import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createUserRoutes(startPath: string) {
  return [
    {
      path: startPath,
      component: () => import('../layouts/profile-settings-layout.vue'),
      redirect: () => ({ name: routeDefinitions.user.general }),
      children: [
        {
          path: '',
          name: routeDefinitions.user.general,
          component: () => import('../views/profile.vue')
        },
        {
          path: 'application-preferences',
          name: routeDefinitions.user.applicationPreferences,
          component: () => import('../views/application-preferences.vue')
        },
        {
          path: 'localization',
          name: routeDefinitions.user.localization,
          component: () => import('../views/localization.vue')
        },
        {
          path: 'feature-flags',
          name: routeDefinitions.user.featureFlags,
          component: () => import('../views/feature-flags.vue')
        }
      ]
    }
  ] as readonly RouteRecordRaw[]
}
